// Validates if a string is a valid IPv4 address (e.g. "192.168.100.100")
export const isValidIpAddress = (ipAddress: string): boolean => {
  const regex =
    /^(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}$/;
  return regex.test(ipAddress);
};
